import { Component } from '@angular/core';

declare var $;
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  year: number = new Date().getFullYear();
  click(){
    if ($('.dropdown-menu.contact-menu').is(":hidden")){
      $('.dropdown-menu.contact-menu').dropdown('toggle');
    }
  }
}
